export default "__VITE_ASSET__CbixmZiB__"